/**
 * Better Auth client for the React frontend.
 *
 * Why same-origin (no explicit baseURL):
 *
 *   In dev, Vite proxies /api/* to localhost:3001 so the browser sees
 *   every request as same-origin (localhost:5174 → /api/...). Cookies
 *   set by Better Auth on the orchestrator side flow through the proxy
 *   without any cookieDomainRewrite gymnastics.
 *
 *   In production, Caddy serves both the static frontend and /api/* from
 *   the same hostname (rondel.ecumene.ai), so the same code path works
 *   without modification.
 *
 *   If we ever split the frontend onto a different origin (CDN, separate
 *   domain), this would need an explicit baseURL + a CORS/credentials
 *   pass on the orchestrator. Don't do that without budgeting time for
 *   §11 of docs/spec/AUTH-AND-DEPLOYMENT.md.
 *
 * The exports below are intentionally minimal — `signIn`, `signOut`, and
 * `useSession` are what the rest of the app needs. Other endpoints
 * (admin, password reset, etc.) get added as we grow the surface.
 */

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  // No baseURL on purpose — same-origin via Vite proxy in dev,
  // same-origin via Caddy in prod.
  basePath: "/api/auth",
});

export const { signIn, signOut, useSession } = authClient;
